import ManagementView from './ManagementView';

export default ManagementView;



// WEBPACK FOOTER //
// ./src/views/payoutsAndTaxes/management/index.js